export const URL_GET_STAFF_LIST = "/v1/gocheckin/staff/site/list?";
export const URL_ADD_STAFF = "/v1/gocheckin/staff/form/create";
export const URL_UPDATE_STAFF = "/v1/gocheckin/staff/form/update";
export const URL_DELETE_STAFF = "/v1/gocheckin/staff/form/delete?";
export const URL_GET_WORKING_HOUR = "/v1/gocheckin/staff/work-hour/info?";
export const URL_UPDATE_WORKING_HOUR = "/v1/gocheckin/staff/work-hour/update?";
export const URL_GET_SERVICE_LIST = "/v1/gocheckin/service/site/list-by-category";
export const URL_GET_STAFF_SERVICE_LIST = "/v1/gocheckin/staff/employee-service/list-service-by-staff?";
export const URL_ADD_SERVICE_TO_STAFF = "/v1/gocheckin/staff/employee-service/add-list-services";
// export const URL_ADD_SERVICE_TO_STAFF = "/v1/gocheckin/staff/employee-service/add-service";
// export const URL_REMOVE_SERVICE_FROM_STAFF = "/v1/gocheckin/staff/employee-service/remove-service";
export const URL_REMOVE_SERVICE_FROM_STAFF = "/v1/gocheckin/staff/employee-service/remove-list-services";
export const UPDATE_BOOKING_STAFF_URL = "/v1/gocheckin/staff/form/update-role-appointment";
export const URL_DRAG_STAFF = "/v1/gocheckin/staff/form/sort";
export const URL_LIST_COMMISSION_BY_STAFF = "/v1/pos/commission/site/list-by-staff?";
export const URL_CHANGE_STAFF_COMMISSION = "/v1/gocheckin/staff/form/update-staff-commission";
export const URL_UPDATE_COMMISION = "/v1/gocheckin/staff/form/save-commission";

export const URL_GET_PERMISSION_LIST = "/v1/gocheckin/staff/site/list-permission";